import axios from 'axios'
import apiList from './resource.js'

export default {
  // 轮播图获取
  subscribeGetBanner: function (data, successfn, errorfn) {
    return axios.get(apiList.common.getBanner, {
      params: data
    })
    .then((res) => {
      successfn && successfn(res.data)
    })
    .catch((res) => {
      errorfn && errorfn(res.data)
    })
  },
  // 课程顾问获取
  consultant: function (successfn, errorfn) {
    return axios.get(apiList.course.consultant)
    .then((res) => {
      successfn && successfn(res.data)
    })
    .catch((res) => {
      errorfn && errorfn(res.data)
    })
  },
  // 约课列表查询
  getAppointList: function (data, successfn, errorfn) {
    return axios
      .get(apiList.course.appointList, {
        params: data
      })
      .then(res => {
        successfn && successfn(res.data)
      })
      .catch(res => {
        errorfn && errorfn(res.data)
      })
  },
  // 用户预约课程
  courseAppoint: function (data, successfn, errorfn) {
    return axios
      .get(apiList.course.courseAppoint, {
        params: data
      })
      .then(res => {
        successfn && successfn(res.data)
      })
      .catch(res => {
        errorfn && errorfn(res.data)
      })
  }
}



// WEBPACK FOOTER //
// ./src/fetch/subscribe.js